import styled, { DefaultTheme } from 'styled-components';

import Caption from '../typography/Caption';
import Subtitle02 from '../typography/Subtitle02';
import { CALENDAR_WIDTH, CALENDAR_WITH_WEEKS_WIDTH } from './constants';
import Day, { DAY_WIDTH } from './Day.styled';

type RootCalendarStyledProps = {
    error: boolean;
    showWeekNumbers: boolean;
    standalone?: boolean;
};

const getBorderStyle = ({ theme, standalone, error }: RootCalendarStyledProps & { theme: DefaultTheme }) => {
    if (!error && !standalone) {
        return undefined;
    }

    if (error) {
        return `border: 1px solid ${ theme.semanticColor.error }`;
    }

    return `border: 1px solid ${ theme.semanticColor.border }`;
};

export const Root = styled.div<RootCalendarStyledProps>`
    background-color: ${ ({ theme }) => theme.color.grey.grey_0 };
    border-radius: ${ ({ theme }) => theme.radius.radius_5 };
    box-shadow: ${ ({ standalone, theme }) => (standalone ? 'none' : theme.shadow.shadow_3) };
    overflow: hidden;
    position: relative;
    user-select: none;
    width: ${ ({ showWeekNumbers }) => {
        return showWeekNumbers ? CALENDAR_WITH_WEEKS_WIDTH : CALENDAR_WIDTH;
    } }px;

    ${ getBorderStyle }
`;

export const Header = styled.div`
    background-color: ${ ({ theme }) => theme.color.white };
    border-bottom: 1px solid ${ ({ theme }) => theme.color.grey.grey_10_hover };
    display: flex;
    flex-direction: column;
`;

export const Controls = styled.div`
    align-items: center;
    display: flex;
    height: 40px;
`;

export const StyledCaption = styled(Caption)`
    margin-left: ${ ({ theme }) => theme.size.size_20 };
    margin-top: ${ ({ theme }) => theme.size.size_10 };
`;

export const Asterisk = styled.span`
    color: ${ ({ theme }) => theme.semanticColor.primary };
    margin-left: ${ ({ theme }) => theme.size.size_5 };
`;

export const Arrow = styled.div`
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 40px;
    justify-content: center;
    width: 40px;

    svg {
        width: auto;
    }

    svg use {
        fill: ${ ({ theme }) => theme.semanticColor.icon_01 };
    }

    &:hover {
        background-color: ${ ({ theme }) => theme.semanticColor.highlightPrimary };

        svg use {
            fill: ${ ({ theme }) => theme.semanticColor.primary };
        }
    }

    &:active {
        background-color: ${ ({ theme }) => theme.semanticColor.focus };

        svg use {
            fill: ${ ({ theme }) => theme.semanticColor.primary };
        }
    }

    &:first-of-type {
        & > * {
            transform: rotateZ(180deg);
        }
    }
`;

export const MonthName = styled(Subtitle02)`
    align-items: center;
    display: flex;
    flex: 1;
    height: 40px;
    justify-content: center;
`;

export const Row = styled.div`
    display: flex;
`;

export const DayName = styled(Day)`
    box-shadow: ${ ({ theme }) => theme.shadow.shadow_i4 };
`;

export const WeekNumber = styled(Day)`
    box-shadow: ${ ({ theme }) => theme.shadow.shadow_i3 };
`;

export const RequiredText = styled(Caption)`
    color: ${ ({ theme }) => theme.semanticColor.error };
    top: -20px;
    position: absolute;
    right: 0;
`;

export const DayPlaceholder = styled.div`
  height: ${ DAY_WIDTH }px;
  width: ${ DAY_WIDTH }px;
`;

DayPlaceholder.displayName = 'DayPlaceholder';

type WeekNoType = {
    isLast: boolean;
};

export const WeekNo = styled(Day)<WeekNoType>``;
